module.exports = __webpack_public_path__ + "static/media/2.question.1de8d434.mp4";